// Comprehensive data for Online Pharmacy Platform

export const diseaseCategories = [
  {
    id: 'oncology',
    name: 'Oncology (Cancer)',
    type: 'terminal',
    icon: 'Activity',
    image: 'https://images.unsplash.com/photo-1579154204601-01588f351e67',
    description: 'Cancer treatment medications including chemotherapy, targeted therapy, and immunotherapy',
    productCount: 150,
    avgSavings: '75%',
    commonMeds: ['Imatinib', 'Gefitinib', 'Sorafenib']
  },
  {
    id: 'hepatitis',
    name: 'Hepatitis & Liver Diseases',
    type: 'chronic',
    icon: 'Heart',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef',
    description: 'Hepatitis B, C treatment and liver disease management medications',
    productCount: 80,
    avgSavings: '78%',
    commonMeds: ['Sofosbuvir', 'Tenofovir', 'Entecavir']
  },
  {
    id: 'hiv',
    name: 'HIV/AIDS',
    type: 'chronic',
    icon: 'Shield',
    image: 'https://images.unsplash.com/photo-1584515933487-779824d29309',
    description: 'Antiretroviral therapy and HIV management medications',
    productCount: 120,
    avgSavings: '72%',
    commonMeds: ['TDF/FTC', 'Dolutegravir', 'Efavirenz']
  },
  {
    id: 'cardiovascular',
    name: 'Cardiovascular Diseases',
    type: 'chronic',
    icon: 'HeartPulse',
    image: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd',
    description: 'Heart disease, hypertension, and cholesterol management',
    productCount: 95,
    avgSavings: '68%',
    commonMeds: ['Atorvastatin', 'Clopidogrel', 'Enalapril']
  },
  {
    id: 'diabetes',
    name: 'Diabetes',
    type: 'chronic',
    icon: 'Droplet',
    image: 'https://images.unsplash.com/photo-1615485500704-8e990f9900f7',
    description: 'Type 1 & 2 diabetes management including insulin and oral medications',
    productCount: 110,
    avgSavings: '70%',
    commonMeds: ['Metformin', 'Insulin', 'Empagliflozin']
  },
  {
    id: 'nephrology',
    name: 'Kidney Diseases',
    type: 'chronic',
    icon: 'Pill',
    image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926',
    description: 'Chronic kidney disease, dialysis, and renal care medications',
    productCount: 75,
    avgSavings: '73%',
    commonMeds: ['Cinacalcet', 'Sevelamer', 'Darbepoetin']
  },
  {
    id: 'respiratory',
    name: 'Respiratory Diseases',
    type: 'chronic',
    icon: 'Wind',
    image: 'https://images.unsplash.com/photo-1628595351029-c2bf17511435',
    description: 'Asthma, COPD, and chronic respiratory condition management',
    productCount: 85,
    avgSavings: '65%',
    commonMeds: ['Budesonide', 'Tiotropium', 'Montelukast']
  },
  {
    id: 'rheumatology',
    name: 'Rheumatology',
    type: 'chronic',
    icon: 'Bone',
    description: 'Rheumatoid arthritis, lupus, and autoimmune disease treatments',
    productCount: 90,
    avgSavings: '76%',
    commonMeds: ['Methotrexate', 'Hydroxychloroquine', 'Adalimumab']
  },
  {
    id: 'neurology',
    name: 'Neurological Disorders',
    type: 'chronic',
    icon: 'Brain',
    description: 'Epilepsy, Parkinsons, MS, and neurological condition management',
    productCount: 100,
    avgSavings: '71%',
    commonMeds: ['Levetiracetam', 'Levodopa', 'Glatiramer']
  },
  {
    id: 'transplant',
    name: 'Transplant Medications',
    type: 'chronic',
    icon: 'Syringe',
    description: 'Immunosuppressants for organ transplant patients',
    productCount: 65,
    avgSavings: '74%',
    commonMeds: ['Tacrolimus', 'Mycophenolate', 'Cyclosporine']
  },
  {
    id: 'gastroenterology',
    name: 'Gastroenterology',
    type: 'chronic',
    icon: 'Activity', // Using a generic icon as stomach/digestive might not exist in feather
    description: 'Digestive disorders, IBD, and gastrointestinal medications',
    productCount: 85,
    avgSavings: '78%',
    commonMeds: ['Omeprazole', 'Mesalamine', 'Infliximab']
  },
  {
    id: 'dermatology',
    name: 'Dermatology',
    type: 'chronic',
    icon: 'Sun', // Approximating skin/dermatology
    description: 'Psoriasis, eczema, and chronic skin condition treatments',
    productCount: 45,
    avgSavings: '80%',
    commonMeds: ['Isotretinoin', 'Ustekinumab', 'Dupilumab']
  },
  {
    id: 'hematology',
    name: 'Hematology',
    type: 'chronic',
    icon: 'Activity', // Approximating blood/hematology
    description: 'Blood disorders, anemia, and clotting condition treatments',
    productCount: 40,
    avgSavings: '75%',
    commonMeds: ['Rivaroxaban', 'Deferasirox', 'Eltrombopag']
  },
  {
    id: 'infectious',
    name: 'Infectious Diseases',
    type: 'specialty',
    icon: 'Shield', // Approximating protection/immunity
    description: 'Tuberculosis, fungal infections, and chronic infectious diseases',
    productCount: 50,
    avgSavings: '85%',
    commonMeds: ['Rifampin', 'Voriconazole', 'Isoniazid']
  },
  {
    id: 'mentalhealth',
    name: 'Mental Health',
    type: 'chronic',
    icon: 'User', // Approximating mind/person
    description: 'Depression, anxiety, bipolar, and psychiatric medication management',
    productCount: 40,
    avgSavings: '85%',
    commonMeds: ['Sertraline', 'Quetiapine', 'Lithium']
  }
];

export const costComparisonData = [
  {
    category: 'Oncology',
    medication: 'Imatinib 400mg',
    usPrice: '$8,500',
    indianPrice: '$540',
    savings: '$7,960',
    savingsPercent: '94%',
    annualUSSavings: '$95,520'
  },
  {
    category: 'Hepatitis C',
    medication: 'Sofosbuvir 400mg',
    usPrice: '$28,000',
    indianPrice: '$2,160',
    savings: '$25,840',
    savingsPercent: '92%',
    annualUSSavings: '$25,840'
  },
  {
    category: 'HIV',
    medication: 'TDF/FTC Combination',
    usPrice: '$2,200',
    indianPrice: '$540',
    savings: '$1,660',
    savingsPercent: '75%',
    annualUSSavings: '$19,920'
  },
  {
    category: 'Diabetes',
    medication: 'Insulin Glargine',
    usPrice: '$6,000',
    indianPrice: '$1,800',
    savings: '$4,200',
    savingsPercent: '70%',
    annualUSSavings: '$50,400'
  },
  {
    category: 'Cardiovascular',
    medication: 'Clopidogrel 75mg',
    usPrice: '$480',
    indianPrice: '$120',
    savings: '$360',
    savingsPercent: '75%',
    annualUSSavings: '$4,320'
  }
];

export const trustIndicators = {
  yearsInBusiness: 45,
  countriesServed: 30,
  medicationsAvailable: 1000,
  patientsServed: '50,000+',
  averageSavings: '72%',
  satisfactionRate: '98%'
};

export const testimonials = [
  {
    id: 1,
    name: 'Robert Thompson',
    age: 58,
    condition: 'Chronic Myeloid Leukemia',
    country: 'United States',
    medication: 'Imatinib 400mg',
    treatmentDuration: '3 years',
    savings: '$95,000+',
    rating: 5,
    verified: true,
    image: 'https://i.pravatar.cc/150?img=12',
    testimonial: 'I was diagnosed with CML and the cost of Gleevec in the US was devastating - $8,500 per month. MediSeller provided authentic Imatinib at $540 per month. Over 3 years, I\'ve saved over $95,000. The quality is identical, verified by my oncologist. This service literally saved my financial future while treating my cancer.'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    age: 45,
    condition: 'Hepatitis C',
    country: 'United Kingdom',
    medication: 'Sofosbuvir + Velpatasvir',
    treatmentDuration: '12 weeks',
    savings: '$42,000',
    rating: 5,
    verified: true,
    image: 'https://i.pravatar.cc/150?img=5',
    testimonial: 'Hepatitis C treatment in the UK was going to cost me £84,000. Through MediSeller, I got the complete 12-week course for £3,200. I\'m now cured and debt-free. The medications were authentic, properly packaged, and delivered quickly. Life-changing service!'
  },
  {
    id: 3,
    name: 'Michael Chen',
    age: 42,
    condition: 'HIV/AIDS',
    country: 'Canada',
    medication: 'Antiretroviral Therapy',
    treatmentDuration: 'Ongoing (4 years)',
    savings: '$80,000+',
    rating: 5,
    verified: true,
    image: 'https://i.pravatar.cc/150?img=33',
    testimonial: 'Managing HIV in Canada costs $2,200/month for medications. MediSeller provides the same quality generics for $540/month. Over 4 years, I\'ve saved $80,000. My viral load is undetectable, and I\'m living a normal, healthy life without financial stress.'
  },
  {
    id: 4,
    name: 'Emma Rodriguez',
    age: 52,
    condition: 'Rheumatoid Arthritis',
    country: 'Australia',
    medication: 'Adalimumab (Biosimilar)',
    treatmentDuration: '2 years',
    savings: '$48,000',
    rating: 5,
    verified: true,
    image: 'https://i.pravatar.cc/150?img=9',
    testimonial: 'Humira costs $4,500/month in Australia. The biosimilar from MediSeller costs $1,500/month with the same effectiveness. My rheumatologist confirmed the quality. I\'ve regained mobility and saved $48,000 in 2 years. Incredible service!'
  },
  {
    id: 5,
    name: 'James Wilson',
    age: 67,
    condition: 'Type 2 Diabetes',
    country: 'United States',
    medication: 'Insulin Glargine',
    treatmentDuration: 'Ongoing (5 years)',
    savings: '$126,000+',
    rating: 5,
    verified: true,
    image: 'https://i.pravatar.cc/150?img=52',
    testimonial: 'Insulin was costing me $500/month in the US. Through MediSeller, I pay $150/month for the same quality. Over 5 years, that\'s $126,000 saved. My A1C levels are perfect, and I can afford my medications without choosing between insulin and other necessities.'
  },
  {
    id: 6,
    name: 'Linda Patterson',
    age: 61,
    condition: 'Chronic Kidney Disease',
    country: 'New Zealand',
    medication: 'Kidney Disease Management',
    treatmentDuration: 'Ongoing (3 years)',
    savings: '$36,000',
    rating: 5,
    verified: true,
    image: 'https://i.pravatar.cc/150?img=24',
    testimonial: 'Managing CKD requires multiple medications. The cost in NZ was overwhelming. MediSeller reduced my medication expenses by 70%. The consultation process was professional, delivery was reliable, and my kidney function has remained stable.'
  }
];

export const howToOrderSteps = [
  {
    step: 1,
    title: 'Select Disease Category',
    description: 'Browse our comprehensive disease categories and select your condition',
    icon: 'Search',
    action: 'Browse Categories'
  },
  {
    step: 2,
    title: 'Upload Prescription',
    description: 'Upload your valid prescription or medical documents securely',
    icon: 'Upload',
    action: 'Upload Documents'
  },
  {
    step: 3,
    title: 'Expert Consultation',
    description: 'Our licensed pharmacists review and verify your requirements',
    icon: 'UserCheck',
    action: 'Get Consultation'
  },
  {
    step: 4,
    title: 'Receive Quote',
    description: 'Get detailed pricing with cost comparison to local prices',
    icon: 'DollarSign',
    action: 'View Pricing'
  },
  {
    step: 5,
    title: 'Secure Payment',
    description: 'Pay securely through our certified payment gateway',
    icon: 'CreditCard',
    action: 'Make Payment'
  },
  {
    step: 6,
    title: 'Quality Assurance',
    description: 'Medications are quality-checked and prepared for shipment',
    icon: 'ShieldCheck',
    action: 'Track Order'
  },
  {
    step: 7,
    title: 'Express Delivery',
    description: 'Receive medications via temperature-controlled express shipping',
    icon: 'Plane',
    action: 'Track Package'
  }
];

export const paymentGatewayInfo = {
  certified: true,
  methods: ['Credit Card', 'Debit Card', 'Wire Transfer', 'PayPal', 'Bank Transfer'],
  security: ['PCI DSS Compliant', '256-bit SSL Encryption', '3D Secure Authentication'],
  currencies: ['USD', 'EUR', 'GBP', 'AUD', 'CAD'],
  features: [
    'Secure checkout process',
    'Multiple currency support',
    'Installment payment options',
    'Refund & cancellation policy',
    'Transaction history & receipts'
  ]
};

export const expertConsultationInfo = {
  availability: '24/7 Support Available',
  responseTime: 'Within 4 hours',
  consultationTypes: [
    'Medication Verification',
    'Dosage Guidance',
    'Treatment Planning',
    'Cost Comparison',
    'Prescription Review',
    'Alternative Options'
  ],
  experts: [
    {
      name: 'Dr. Rajesh Kumar',
      qualification: 'PharmD, Clinical Pharmacist',
      experience: '18 years',
      specialty: 'Oncology & Chronic Diseases'
    },
    {
      name: 'Dr. Priya Sharma',
      qualification: 'PharmD, Hospital Pharmacist',
      experience: '15 years',
      specialty: 'Cardiovascular & Diabetes'
    },
    {
      name: 'Dr. Amit Patel',
      qualification: 'PharmD, Specialty Pharmacist',
      experience: '20 years',
      specialty: 'HIV/AIDS & Infectious Diseases'
    }
  ]
};

export const companyLegacy = {
  founded: 1980,
  milestone: [
    { year: 1980, event: 'MediSeller founded in Mumbai, India' },
    { year: 1995, event: 'Started international export services' },
    { year: 2005, event: 'Expanded to 20+ countries' },
    { year: 2010, event: 'Specialized in chronic & terminal disease medications' },
    { year: 2015, event: 'Launched online consultation services' },
    { year: 2020, event: 'Served 50,000+ patients globally' },
    { year: 2025, event: '45 years of trusted pharmaceutical services' }
  ],
  certifications: [
    'WHO-GMP Certified',
    'ISO 9001:2015',
    'FDA Recognized',
    'Licensed Exporter',
    'Cold Chain Certified'
  ],
  partnerships: [
    'Cipla', 'Natco Pharma', 'Dr. Reddys', 'Sun Pharma',
    'Biocon', 'Lupin', 'Aurobindo', 'Zydus Cadila'
  ]
};

export default {
  diseaseCategories,
  costComparisonData,
  trustIndicators,
  testimonials,
  howToOrderSteps,
  paymentGatewayInfo,
  expertConsultationInfo,
  companyLegacy
};